<template>
  <v-app id="inspire">
    <router-view></router-view>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import compareAsc from "date-fns/compareAsc";
export default {
  name: "MainAppComponent",
  computed: {
    ...mapGetters(["user"])
  },
  components: {},
  methods: {
    getUser() {
      const user = this.user;
      if (user._id != undefined) {
        const self = this;
        const res = this.$store
          .dispatch("get", "/user/" + user._id)
          .then(res => {
            const userData = res.user;
            const subscription = res.subscription;
            if (subscription && res.user.accountType == "expert") {
              userData.endsAt = subscription.endsAt;
              userData.subscription = true;
              userData.userExpertise = subscription.expertise;
            } else if (subscription && res.user.accountType == "vip_sonko") {
              userData.endsAt = subscription.endsAt;
              userData.subscription = true;
              userData.userExpertise = subscription.expertise;
            } else {
              userData.subscription = false;
            }
            userData.isAdmin = res.user.admin;
            self.$store.commit("setUser", userData);
          })
          .finally(() => {
            self.verify();
          });
      }
    },
    verify() {
      const user = this.user;
      // check expiry
      if (user.expired == true) {
        if(user.accountType == 'vip_sonko') {
          this.$router.push("/vip_sonko/expiry");
        } else {
          this.$router.push("/expiry");
        }
      }
      // end of check

      // check active
      if (user.active == false && user.isAdmin == false && user.editor == false && user.manager == false) {
        if(user.accountType == 'vip_sonko') {
          this.$router.push("/vip_sonko/inactive");
        } else {
          this.$router.push("/inactive");
        }
      }
      // end of check

      // ckeck verified
      if (user && user.verified == false && user.editor == false && user.manager == false) {
        if(user.accountType == 'vip_sonko') {
          this.$router.push(`/verify/vip_sonko/${user._id}`);
        } else {
          this.$router.push(`/verify/expert/${user._id}`);  
        }
      }
      // end of verified check
      console.log(user);
      // check subscription
      if (user && user.subscription == false && user.accountType == "expert") {
        this.$router.push("/packages");
      }
      
      if (user && user.subscription == false && user.accountType == "vip_sonko") {
        this.$router.push("/vip_sonko/packages");
      }
      // end

      // check expertise
      if (user && user.expertise.length < 1 && user.accountType == "expert") {
        this.$router.push("/expertise/update/expert");
      }

      if (user && user.expertise.length < 1 && user.accountType == "sonko") {
        this.$router.push("/expertise/update/sonko");
      }

      if (user && (user.locationOne == null || user.locationOne == undefined) && user.accountType == "vip_sonko" && user.subscription == true) {
        this.$router.push("/vip_sonko/location/update/vip_sonko");
      }
      // end
    }
  },
  created() {
    this.getUser();
  }
};
</script>


<style lang="css">
@import url("https://fonts.googleapis.com/css?family=Montserrat:500&display=swap");

.application {
  font-family: "Montserrat", sans-serif;
}
</style>